import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import NewQuestionForm from '../../../forms/new-question';
import Modal from '../../../shared/modal';

import style from './index.module.scss'; 

class MainMobileNav extends Component {
  state = {
    open: false,
  }; 
 
  onOpenModal = () =>
    this.setState({
      open: true,
    });

  onCloseModal = () =>
    this.setState({
      open: false,
    });

  render() {
    const { open } = this.state;
    const { nav, label, logo, icon } = style;

    return (
      <nav className={`row ${nav}`}>
        <div className={`col ${style['col--search']}`}>
          <span style={{ cursor: 'pointer'}}>
            <i className={`fas fa-search ${icon}`}></i>{' '}
            <span className={label}>Search</span>
          </span>
        </div>
        <div className={`col ${style['col--logo']}`}>
          <Link to="/home">
            <img src="/images/quora-logo.png" alt="Quora Logo" className={logo} />
          </Link>
        </div>
        <div className={`col ${style['col--add-ques']}`}>
          <span style={{ cursor: 'pointer'}} onClick={this.onOpenModal}>
            <i className={`far fa-plus-square ${icon}`}></i>{' '}
            <span className={label}>Add</span>
          </span>
          <Modal
            isModalOpen={open}
            isFooterDisplayed={false}
            openModal={this.onOpenModal}
            closeModal={this.onCloseModal}
            label='Add Question'
          >
            <NewQuestionForm
              openModal={this.onOpenModal}
              closeModal={this.onCloseModal}
            />
          </Modal>
        </div>
      </nav>
    );
  }
}

export default MainMobileNav;
